(function () {
    var form = document.getElementById('contact-form');
    if (!form) {
        return;
    }

    var status = document.getElementById('contact-form-status');
    var submitBtn = form.querySelector('button[type="submit"]');

    function setStatus(message, tone) {
        status.textContent = message;
        status.className = 'form-status' + (tone ? ' is-' + tone : '');
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Honeypot: bots tend to fill every field, humans never see this one.
        if (form.company.value) {
            setStatus('Thanks — your message has been sent.', 'success');
            form.reset();
            return;
        }

        var name = form.name.value.trim();
        var email = form.email.value.trim();
        var subject = form.subject.value.trim();
        var message = form.message.value.trim();

        if (!name || !email || !subject || !message) {
            setStatus('Please fill in every field before sending.', 'error');
            return;
        }

        submitBtn.disabled = true;
        setStatus('Sending…', '');

        fetch('/api/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                name: name,
                email: email,
                subject: subject,
                message: message,
                timestamp: Date.now()
            })
        })
            .then(function (res) {
                if (res.status === 429) {
                    throw new Error('rate-limited');
                }
                if (!res.ok) {
                    throw new Error('request-failed');
                }
                return res.json();
            })
            .then(function () {
                setStatus('Thanks — your message has been sent. We’ll be in touch within 24 hours.', 'success');
                form.reset();
            })
            .catch(function (err) {
                if (err && err.message === 'rate-limited') {
                    setStatus('You’ve sent a few messages already — please wait a few minutes and try again.', 'error');
                } else {
                    setStatus('Something went wrong. Please email us directly at contact@mith.studio.', 'error');
                }
            })
            .then(function () {
                submitBtn.disabled = false;
            });
    });
}());
